import { Check, RotateCcw } from "lucide-react";

const SWATCHES = ["#0F172A", "#1E3A8A", "#0EA5E9", "#0F766E", "#10B981", "#65A30D", "#CA8A04", "#EA580C", "#DC2626", "#BE185D", "#7C3AED", "#52525B"];

export const AccentPicker = ({ value, onChange }) => (
  <div className="mt-5 pt-5 border-t border-white/5" data-testid="accent-picker">
    <div className="flex items-center justify-between mb-3">
      <p className="text-xs font-mono uppercase tracking-widest text-slate-500">Accent colour</p>
      {value && (
        <button onClick={() => onChange(null)} data-testid="accent-reset-btn" className="text-xs text-slate-400 hover:text-white flex items-center gap-1 transition-colors">
          <RotateCcw className="h-3 w-3" /> Template default
        </button>
      )}
    </div>
    <div className="flex flex-wrap items-center gap-2">
      {SWATCHES.map((c) => (
        <button key={c} onClick={() => onChange(c)} data-testid={`accent-swatch-${c.slice(1)}`} aria-label={`Accent ${c}`}
          className="h-7 w-7 rounded-full ring-1 ring-white/40 ring-offset-2 ring-offset-[#12151E] flex items-center justify-center transition-transform hover:scale-110" style={{ background: c }}>
          {value?.toUpperCase() === c && <Check className="h-3.5 w-3.5 text-white" />}
        </button>
      ))}
      <label className="relative h-7 w-7 rounded-full border border-dashed border-white/30 overflow-hidden cursor-pointer" title="Custom colour"
        style={{ background: value && !SWATCHES.includes(value.toUpperCase()) ? value : "conic-gradient(red, yellow, lime, cyan, blue, magenta, red)" }}>
        <input type="color" value={value || "#10b981"} onChange={(e) => onChange(e.target.value.toUpperCase())} data-testid="accent-custom-input"
          className="absolute inset-0 opacity-0 cursor-pointer" />
      </label>
    </div>
  </div>
);
